<template>
  <v-navigation-drawer v-model="drawer.model" :temporary="true" app overflow>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{appState.user.name}}</v-list-item-title>
          <v-list-item-subtitle>{{appState.user.email}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-list nav>
      <v-list-item 
        v-for="item in items" :key="item.title"
        @click=""
        :to="item.to"
        link>
        <v-list-item-icon v-if="item.icon">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item 
        :href="appState.logoutUrl"
        link>
        <v-icon>logout</v-icon>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    drawer: Object
  },
  data: () => ({
    items: [
      {title: 'Home', to: {name:'home'}},
      {title: 'Accounts', to: {name:'accounts'}},
      {title: 'Categories', to: {name:'categories'}},
      {title: 'Tags', to: {name:'tags'}},
      {title: 'Transactions', to: {name:'transactions'}},
    ]
  })
};
</script>
